module.exports = __webpack_public_path__ + "img/s00162.508095b1.png";